import { getDataDetailUrl, getJobDetailUrl } from "@helpers/constants";

import { parseResourceFromExpression, type Rule } from "./types";

// Detail-page link for the resource a grant targets, or null if there's nowhere
// to go. Data detail is keyed by the resource's full name, jobs by id. Shared by
// the table's "Go to resource" row action and the rule detail drawer's
// "View resource" button.
export function getResourceLink(row: Rule): string | null {
  const resource = parseResourceFromExpression(row.expression);
  if (!resource) return null;
  if (resource.type === "data" && row.resource.name) {
    return getDataDetailUrl(row.resource.name);
  }
  if (resource.type === "job") {
    return getJobDetailUrl(resource.id);
  }
  return null;
}
